export default class DOMEvents {
  static readonly change = 'change';
  static readonly click = 'click';
  static readonly input = 'input';
  static readonly keyPress = 'keypress';
  static readonly mouseLeave = 'mouseleave';
  static readonly scroll = 'scroll';
}
